
import { MergeCatalog } from '../merge.catalog';
import { MergeDatasetData } from '../model/merge.dataset.data';
import { getMergeDataset } from '../utilities/get.merge.dataset';
import { titleize } from 'inflected';

export const MergeDataset = (options?: Partial<MergeDatasetData>): ClassDecorator => {
    return (target: Function) => {
        const meta = getMergeDataset(target.prototype);

        const dataset = {
            ...meta,
            name: target.name,
            displayName: titleize(target.name),

            ...options
        } as MergeDatasetData;

        MergeCatalog.registerDataset(dataset);
    };
};
